<div class="activity-feed-container">
  @if (isLoading) {
    <div class="activity-loading-state">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else if (hasError) {
    <div class="activity-error-state">
      <mat-icon class="empty-icon">error_outline</mat-icon>
      <p>Couldn't load recent activity</p>
      <button mat-stroked-button (click)="retry()">Try again</button>
    </div>
  } @else if (totalCount === 0) {
    <div class="activity-empty-state">
      <mat-icon class="empty-icon">history</mat-icon>
      <p>No recent activity</p>
    </div>
  } @else {
    <!-- One container holds the table and its paginator, so the paginator renders as
         the table's footer band — same structure as the resource directory. The
         paginator hangs off totalCount, NOT the current page's row count: a page can
         come back empty while data still exists (events aged out of the server's
         window while the viewer sat on a later page), and the paginator is the only
         control that gets them back to page 1. -->
    <div class="activity-table-container">
      <div class="activity-table-scroll">
        @if (rows.length > 0) {
          <table mat-table [dataSource]="rows" class="activity-table">
            <!-- Message Column -->
            <ng-container matColumnDef="message">
              <th mat-header-cell *matHeaderCellDef>Activity</th>
              <td
                mat-cell
                *matCellDef="let row"
                [innerHTML]="getDisplayMessage(row)"
                (click)="onMessageClick($event)"
              ></td>
            </ng-container>

            <!-- Date Column -->
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef>Date</th>
              <td mat-cell *matCellDef="let row">
                {{ row.createdAt | date: 'MMM d, y h:mm a' }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        } @else {
          <p class="activity-stale-page">No activity on this page</p>
        }
      </div>

      <!-- Server-side paging: length comes from the API's total, not the loaded rows -->
      <mat-paginator
        class="activity-paginator"
        [length]="totalCount"
        [pageIndex]="page - 1"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPage($event)"
        showFirstLastButtons
        aria-label="Select page of recent activity"
      ></mat-paginator>
    </div>
  }
</div>
